const $ = jQuery.noConflict();

class Slider {
    constructor( selector, args = {} ) {
        this.selector = selector;
        this.args = args;
    }

    getDefaultSlickSettings() {
        return {
            dots: false,
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnHover: false,
            speed: 600,
        }
    }

    /**
     * Override our default slick settings with args provided to the class.
     */
    getSlickSettings() {
        return Object.assign( {}, this.getDefaultSlickSettings(), this.args );
    }

    init() {

		if (!$(this.selector).length) {
            return;
        }

		 // Set max-width to slider captions when variableWidth = true
		 $(this.selector).on('setPosition', () => {
			$(this.selector).find('figcaption').each((i, item) => {
				const caption = $(item);
				const width = caption.closest('figure').find('img').width();
				caption.css('max-width', width > 0 ? `${width}px` : '');
			});
		});


        let settings = this.getSlickSettings();

        $( this.selector ).slick( settings );
    }
}

const SimpleSlider = new Slider('.gallery-slider__slider');
const TestimonialSlider = new Slider('.testimonial-slider', {
	dots: true
});
const FluidSlider = new Slider(
    '.block-slider-gallery--hard .gallery-slider__slider-fluid',
    {
        centerMode: true,
        variableWidth: true,
    }
);
const FlexibleSlider = new Slider(
    '.block-slider-gallery--flexible .gallery-slider__slider-fluid',
    {
        centerMode: true,
        variableWidth: true,
		responsive: [
            {
                breakpoint: 1290,
                settings: {
                    centerMode: false,
                    variableWidth: false,
                },
            },
        ],
    }
);

const LinkSlider = new Slider(
    '.image-link-slider',
    {

		slidesToShow: 5,
        slidesToScroll: 1,
		responsive: [
			{

                breakpoint: 1200,
                settings: {
					slidesToShow: 4,
                },
            },
			{

                breakpoint: 992,
                settings: {
					slidesToShow: 3,
                },
            },
            {
                breakpoint: 768,
                settings: {
					slidesToShow: 1,
                    centerMode: true,
                    variableWidth: true,
                },
            },
        ],
    }
);
export { SimpleSlider, TestimonialSlider, FluidSlider, FlexibleSlider, LinkSlider };
